import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, InputGroup, InputGroupText } from "reactstrap";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { loadingFalse } from "../../Reducer/loaderSlice";
import { useDispatch } from "react-redux";

const PaymentModal = ({ isOpen, toggle, invoice, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [paymentData, setPaymentData] = useState({
        amount: "",
        payment_mode: "cash",
        note: ""
    });
    const dispatch = useDispatch();

    // 🔥 Invoice select aagumbodhu pending balance-ah default-ah vachukalam
    useEffect(() => {
        if (invoice) {
            const total = parseFloat(invoice.total_amount || 0);
            const paid = parseFloat(invoice.paid_amount || 0);
            const balance = total - paid;

            setPaymentData({
                ...paymentData,
                amount: balance > 0 ? balance.toFixed(2) : ""
            });
        }
    }, [invoice, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // 🔥 Backend structure-ku yetha maari client_id logic
        const clientId = invoice?.client_id || invoice?.id_client;

        if (!clientId) {
            toast.error("Client ID missing!");
            setLoading(false);
            return;
        }

        const payload = {
            client_id: clientId,
            invoice_id: invoice.id,
            amount: paymentData.amount,
            payment_type: "invoice",
            payment_mode: paymentData.payment_mode,
            note: paymentData.note
        };

        try {
            const res = await Handler({ method: "POST", url: "/payments/create.php", data: payload });
            if (res?.success) {
                Swal.fire("Paid!", "Payment recorded successfully", "success");
                toggle();
                onSuccess(); // List-ah refresh panna
                dispatch(loadingFalse());
            }else{
                dispatch(loadingFalse());
            }
        } catch (err) {
            console.error("Payment Error:", err);
            toast.error(err.response?.data?.message || "Payment failed");
        } finally {
            setLoading(false);
        }
    };

    const pendingBalance = (parseFloat(invoice?.total_amount || 0) - parseFloat(invoice?.paid_amount || 0))?.toLocaleString();

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="bg-theme text-white">
                Collect Payment - {invoice?.invoice_no}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <div className="mb-3 p-3 bg-light rounded border shadow-sm">
                        <div className="d-flex justify-content-between small mb-1">
                            <span className="text-muted">Client Name:</span>
                            <span className="fw-bold text-dark">{invoice?.client_name}</span>
                        </div>
                        <div className="d-flex justify-content-between small mb-1">
                            <span className="text-muted">Total Bill:</span>
                            <span className="fw-bold">₹ {parseFloat(invoice?.total_amount || 0)?.toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between border-top pt-1 mt-1 fs-6">
                            <span className="text-muted fw-bold">Outstanding:</span>
                            <span className="fw-bold text-danger">₹ {pendingBalance}</span>
                        </div>
                    </div>

                    <FormGroup>
                        <Label className="fw-bold small">Amount to Receive</Label>
                        <InputGroup size="lg">
                            <InputGroupText className="bg-white">₹</InputGroupText>
                            <Input
                                type="number"
                                step="any"
                                required
                                value={paymentData.amount}
                                onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })}
                                placeholder="0.00"
                            />
                        </InputGroup>
                    </FormGroup>

                    <FormGroup>
                        <Label className="fw-bold small">Payment Mode</Label>
                        <Input
                            type="select"
                            value={paymentData.payment_mode}
                            onChange={(e) => setPaymentData({ ...paymentData, payment_mode: e.target.value })}
                        >
                            <option value="cash">Cash Collection</option>
                            <option value="bank">Bank / Online Transfer</option>
                        </Input>
                    </FormGroup>

                    <FormGroup className="mb-0">
                        <Label className="fw-bold small">Payment Notes</Label>
                        <Input
                            type="textarea"
                            rows="2"
                            placeholder="Transaction ID, Cheque details or remarks..."
                            value={paymentData.note}
                            onChange={(e) => setPaymentData({ ...paymentData, note: e.target.value })}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="border-0">
                    <Button color="secondary" outline onClick={toggle} className="px-4">Cancel</Button>
                    <Button color="success" type="submit" disabled={loading} className="px-4 fw-bold shadow-sm">
                        {loading ? "Processing..." : "Confirm Payment"}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default PaymentModal;